import { Service } from '@/util/types/serverTypes';
import { AddressForScheduler } from '@/util/types/globalTypes';

export type EscapeHatchReason =
  | 'service-blocked'
  | 'out-of-area'
  | 'size-limit'
  | null;

/**
 * Check if online booking should be blocked due to escape hatch scenarios
 *
 * @returns The reason for blocking, or null if booking is allowed
 */
export function checkEscapeHatch({
  selectedServiceIds,
  services,
  containingServiceAreaArray,
  address,
  maxSqftOnline,
}: {
  selectedServiceIds: string[];
  services: Service[];
  containingServiceAreaArray: any[] | null;
  address: AddressForScheduler | null;
  maxSqftOnline?: number;
}): EscapeHatchReason {
  // Scenario 1: Check if any selected service has excludeFromScheduler flag
  const hasBlockedService = selectedServiceIds.some((serviceId) => {
    const service = services.find((s) => s._id === serviceId);
    return service?.excludeFromScheduler === true;
  });

  if (hasBlockedService) {
    return 'service-blocked';
  }

  // Scenario 2: Check if property is outside service area
  // containingServiceAreaArray will be an empty array [] if no service area contains the property
  if (
    containingServiceAreaArray !== null &&
    Array.isArray(containingServiceAreaArray) &&
    containingServiceAreaArray.length === 0
  ) {
    return 'out-of-area';
  }

  // Scenario 3: Check if property exceeds maximum sqft for online booking
  if (
    address?.sqft &&
    maxSqftOnline !== undefined &&
    maxSqftOnline > 0 &&
    address.sqft > maxSqftOnline
  ) {
    return 'size-limit';
  }

  // No blocking conditions met - allow booking
  return null;
}
